import BaseModel from "../../../common/model/base_model";

export default class SignUpModel extends BaseModel {

    login = '';
    name = '';
    email = '';
    phone = '';
    country_id = '';
    vat_number = '';
    description = '';
    recaptcha_token = '';
    google_authenticator_code = '';
    terms_accepted = false;
    redirect_url = null;

}